<template>
	<!-- 空样式 -->
	   <div class="empty">
	     <img :src="imgurl"  class="img" />
	     <div class="text">{{text}}</div>
	   </div>
</template>

<script>
	export default {
		name:"empty-page",
    props:{
        imgurl:{
            default:'https://www.fkhongdan.com/images/hdlast/empty1.png'
        },
      text:{
        type:String,
        default:'空空如也'
      }
    },
		data() {
			return {
				
			};
		}
	}
</script>

<style  scoped>
  .empty{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: .6rem;
    
    
    
  }
  .img{
      width: 100%;
      height: 168px;
    }
    .text{
      font-size: 14px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      color: #9E9E9E;
      line-height: 20px;
      margin-top: 14px;
    }
</style>
